import PropTypes from 'prop-types';
import { Icon } from 'bv-components';
import { v as bvVar } from 'bv';
import { openMenu } from 'floating-navigation-helpers';
import { BackButton, UserDetails } from './components';

const HeaderView = ({ className, loggedIn, logoClassName }) => (
  <div className={className} id="header">
    <Icon className="floating-nav__header-item" type="header-menu-icon" id="menu" big onClick={openMenu} />
    <BackButton />
    <div className="site-header__logo">
      <a className={logoClassName} href={bvVar('rootPath')}>
        <span role="img" aria-label="Home" />
      </a>
    </div>
    <UserDetails loggedIn={loggedIn} />
  </div>
);

HeaderView.propTypes = {
  className: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  logoClassName: PropTypes.string.isRequired,
};

export default HeaderView;

// TODO: id still used by:
// - ApplicationHelper.scrollToElement (only used by bet finder now)
// We can't use Link element here, we want the link to have href to the root without locale
// As locale is the basename, can't be done with react-router
// Proposal: href to be / but onClick to do history.push to avoid the refresh
